import type { DOMOutputSpec } from "@tiptap/pm/model";

/**
 * The line-number button. The number itself is rendered by a CSS counter on
 * `.line-number::before`, so the spec carries no text.
 */
export const lineNumberSpec: DOMOutputSpec = [
  "button",
  {
    type: "button",
    tabindex: "-1",
    class:
      "line-number text-xxs text-right sm:text-left w-line-number-width sm:w-6.25 text-gray-400 dark:text-gray-600 select-none selection:bg-transparent",
  },
];
